import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Utils from "../../lib/Utils";

const OrderPaid = () => {

    const [user, setUser] = useState();

    useEffect(() => {
        setUser(Utils.GetUser());
    }, [])

    return (
        <div className="d-flex justify-content-center align-items-center fill-page">
            <div className="alert alert-success alert-lg text-center">
                <img className="alert-icon" src={"/icons/check-circle.svg"}/>
                <h1 className="alert-title text-center mb-3">Order completed</h1>
                <p className="text-center mb-5">
                    We are processing your order, Check your inbox at ({ user?.email }) to receive your redeem codes. <br/>If you don't 
                    receive them in 3 days feel free to contact us.
                </p>
                <Link to={'/myorders'} className={"btn btn-lg btn-black"}>Go to orders</Link>
            </div>
        </div>
    )
}

const OrderNotPaid = () => {

    return (
        <div className="d-flex justify-content-center align-items-center fill-page">
            <div className="alert alert-success alert-lg text-center">
                <img className="alert-icon" src={"/icons/check-circle.svg"}/>
                <h1 className="alert-title text-center">Order payment failed</h1>
                <p className="text-center">You can retry order payment at anytime</p>
                <Link to={'/myorders'} className={"btn btn-lg btn-black"}>Go to orders</Link>
            </div>
        </div>
    )
}

export { OrderPaid };